import React from 'react';
import { Dialog } from '@mui/material';
import ALoader from '../../common/a-loader';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { Box, Tooltip } from '@mui/material';
import ADataGrid from '../../common/data-grid/ADataGrid';
import { gridStyles } from '../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg"
import moment from 'moment';

const Logs = ({
    isOpenDialog,
    rows,
    loader,
    currentPage,
    rowCount,
    handleClose,
    totalRecords,
    currentPageSize
}) => {
    const columns = [
        new AGridColDef("updatedBy", "User", false)
            .setMinWidth(100)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("businessArea", "Business Area", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("courseCategory", "Course Category", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value?.label}>
                    <div className={`ellipsis-text-container cursor`}>
                        {params.value?.label}
                    </div>
                </Tooltip> : <div>-</div>
            )),
        new AGridColDef("term", " Term", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("academicGroup", "Academic Group", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("academicCareer", "Carrier", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("amount", "Amount (₹)", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
            
        new AGridColDef("concessionPercentage", "Concession (%)", false)
            .setMinWidth(80)
            .editable(true)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("updatedOn", "Last Updated On", true)
            .setMinWidth(100)
            .editable(true)
            .setFlex(1.2)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={moment(params?.value).format('YYYY-MM-DD hh:mm A')}>
                        <div className={`ellipsis-text-container`}>{moment(params?.value).format('YYYY-MM-DD hh:mm A')}</div>
                    </Tooltip>
                    : <div>-</div>
            ))



    ]
    const onChangeHandler = () => {

    }

    return (
        <Dialog
            open={isOpenDialog}
            fullWidth
            maxWidth="lg"
        >
            {loader && <ALoader position="fixed" />}
            <div className='p-3'>
                <div className='d-flex justify-content-between mb-1'>
                    <div className='regular-large-bold'>Configuration Logs</div>
                    <CloseIcon onClick={handleClose} />
                </div>
                <ADataGrid
                    removeWrapperContainer
                    rows={isOpenDialog || []}
                    columns={columns}
                    rowId={(row) => JSON.stringify(row)}
                    rowHeight={50}
                    loading={loader}
                    rowCount={totalRecords}
                    currentPage={currentPage}
                    sx={gridStyles}
                    hidePagination
                    autoHeight
                    serverPagination={false}
                />

            </div>
        </Dialog>
    )
}

export default Logs;